<template>
    <div class="bottom_navigation">
        <div :class="{ 'is-active': isActive(Sections.MENU) }" @click="clicked(Sections.MENU)">
            <svgicon icon="menu" :fill="false"   class="bottom_navigation__svg" color="currentColor"></svgicon>
            Menu
        </div>
        <div :class="{ 'is-active': isActive(Sections.MAP) } " @click="clicked(Sections.MAP)"
             v-if="data && !data.disableMap">
            <svgicon icon="map" :fill="false" class="bottom_navigation__svg" color="currentColor"></svgicon>
            Map
        </div>
        <div :class="{ 'is-active': isActive(Sections.PROGRAM) }" @click="clicked(Sections.PROGRAM)"
             v-if="isProgramVisible">
            <svgicon icon="programm" :fill="false" color="currentColor" class="bottom_navigation__svg"></svgicon>
            Program
        </div>
        <div :class="{ 'is-active': isActive(Sections.INFO) }" @click="clicked(Sections.INFO)"
             v-if="isInfoVisible">
            <svgicon icon="info"  color="currentColor" :fill="false"  class="bottom_navigation__svg bottom_navigation__info"></svgicon>
            Info
        </div>
    </div>
</template>

<script>
    import Sections from "../constants/sections";

    export default {
        name: "BottomNavigation",
        props: {
            data: Object,
            selectedPage: String
        },
        data() {
            return {
                Sections
            }
        },
        computed: {
            isProgramVisible: function () {
              if (!this.data || !this.data.program || this.data.disableProgram) return false;
              return Object.keys(this.data.program).length > 0;
            },
            isInfoVisible: function () {
                if (!this.data || !this.data.info || !this.data.info.content || this.data.disableInformation) return false;
                return Object.keys(this.data.info.content).length > 0;
            }
        },
        methods: {
            clicked: function (item) {
                this.$emit('select', item);
            },
            isActive: function (value) {
                return value === this.selectedPage;
            }
        },
    }
</script>

<style scoped>

</style>


<style lang="scss">
    @import '../scss/config';

    .bottom_navigation {

        display: flex;
        justify-content: space-around;
        align-items: center;
        position: fixed;
        bottom: 0;
        z-index: 10;

        width: 100%;
        height: 66px;
        background-color: #000000;
        font-size: 15px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.2;
        letter-spacing: normal;
        div {
            cursor:pointer;

            &.is-active {
                color: color(accent);
            }
        }
        &__svg {
            width: size(small);
            height: size(small);
            vertical-align: baseline;
        }

        &__info {
            tspan {
                fill: currentColor;
            }
        }
    }

    .nav-item:hover {
        color: color(accent) !important;
    }

</style>
